//
import * as types from './error-types';

export const disableErrorRouteRedirection = (): types.DISABLE_ERROR_ROUTE_REDIRECTION_ACTION => ({
  type: types.DISABLE_ERROR_ROUTE_REDIRECTION
});
